import React, { PureComponent } from "react";
import {
    timeSecond,
    timeMinute,
    timeHour,
    timeDay,
    timeWeek,
    timeMonth,
    timeYear
  } from "d3-time";
  import { timeFormat } from "d3-time-format";

  var 
    formatHour = timeFormat("%H:%M"),
    formatDay = timeFormat("%e.%m");

const _displayTick = (tick, lastTick) => {
    let time = formatHour(tick)
    if (timeDay(tick).getTime() == timeDay(lastTick).getTime()) {
        return {time, date: ""}
    }
    return {time, date: formatDay(tick)}
}



const XAxis = class extends PureComponent {

/*     shouldComponentUpdate(nextProps){
        return this.props.rerender !== nextProps.rerender
      } */
    
    render() {
        console.log("xAxis rerenders")
        let { xScale, yScale, nTicksX, nTicksY } = this.props;
        //let _tickFormat = xTickFormat;

        let xTicks = xScale.ticks(nTicksX);
        let tickLines = xTicks.map((tick, index) => {
            let scaledTick = xScale(tick);
            //console.log(scaledTick); 
            let yTicks = yScale.ticks(nTicksY)
            let y1 = yScale(yTicks[yTicks.length-1]);
            //console.log(_tickFormat(tick))
            let lastTick = xTicks[index - 1]
            let displayTick = _displayTick(tick, lastTick);
            return (
                <g key={scaledTick}>
                    <text x={scaledTick} y={y1+10} dominantBaseline="hanging" textAnchor="middle" fontSize="12">{displayTick.time}</text>
                    <text x={scaledTick} y={y1+23} dominantBaseline="hanging" textAnchor="middle" fontSize="12">{displayTick.date}</text>

                    <line x1={scaledTick} y1={y1} x2={scaledTick} y2={y1+8} stroke="gray"></line>
                </g>
            )
        })
        //console.log("___")

        return (
            <g>
                {tickLines}
            </g>
        )
    }


}

export default XAxis